/*===========================================
		CUSTOM Javascript 13-09-2019
=============================================*/
// ========================
// ================
// ===============================================
//         JS Settings 
// ===============================================
// ================
// ========================


// ===============================================
//         HEADER
// ===============================================   


// ===============================================
//         HOMEPAGE SECTION
// ===============================================

/* ---- SLIDESHOW ---- */


/*--------Custo block Slick Slider  (custom script)---------*/
function initSlider(){   
    $('.multiple-items').slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
    }
    $(document).ready(function() {
            initSlider();
        });
    
    
// -------------------------------------------
    
// ---------------------------------------------------------------------
// Add Pannel
$(document).ready(function(){
	
	$('ul.tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs li').removeClass('current');
		$('.tab-content').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	})

})

// ---------------------------------------------------------------------
// SideBar Nevigation(accordion)

$(function() {
	var Accordion = function(el, multiple) {
		this.el = el || {};
		this.multiple = multiple || false;

		// Variables privadas
		var links = this.el.find('.site-nav__link');
		// Evento
		links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
	}

	Accordion.prototype.dropdown = function(e) {
		var $el = e.data.el;
			$this = $(this),
			$next = $this.next();

		$next.slideToggle();
		$this.parent().toggleClass('open');

		if (!e.data.multiple) {
			$el.find('.site-nav__submenu').not($next).slideUp().parent().removeClass('open');
		};
	}	

	var accordion = new Accordion($('#accordion'), false);
});


//  $( function() {
//     $( "#accordion" ).accordion();
//   } );
    

// -------------------------------------------

$(document).ready(function(){
    $("#panel").hide();
    $("button").click(function(){
        $("#panel").slideToggle();
    });
});


/*--------Custom image with text ( read more)---------*/
$('.moreless-button').click(function() {
  $('.moretext').slideToggle();
  if ($('.moreless-button').text() == "Read more") {
    $(this).text("Read less")
  } else {
    $(this).text("Read more")
  }
});

    
/*--------Slider(Owl Carousel 2 sync demo with loop/autoplay)script---------*/
$(document).ready(function() {

  var sync1 = $("#sync1");
  var sync2 = $("#sync2");
  var slidesPerPage = 1; //globaly define number of elements per page
  var syncedSecondary = true;

  sync1.owlCarousel({
    items : 1,
    slideSpeed : 2000,
    nav: true,
    autoplay: false,
    dots: true,
    loop: true,
    responsiveRefreshRate : 200,
    navText: ['<svg width="100%" height="100%" viewBox="0 0 11 20"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M9.554,1.001l-8.607,8.607l8.607,8.606"/></svg>','<svg width="100%" height="100%" viewBox="0 0 11 20" version="1.1"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"/></svg>'],
  }).on('changed.owl.carousel', syncPosition);

  sync2
    .on('initialized.owl.carousel', function () {
      sync2.find(".owl-item").eq(0).addClass("current");
    })
    .owlCarousel({
    items : slidesPerPage,
    dots: true,
    nav: true,
    smartSpeed: 200,
    slideSpeed : 500,
    slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
    responsiveRefreshRate : 100
  }).on('changed.owl.carousel', syncPosition2);

  function syncPosition(el) {
    //if you set loop to false, you have to restore this next line
    //var current = el.item.index;
    
    //if you disable loop you have to comment this block
    var count = el.item.count-1;
    var current = Math.round(el.item.index - (el.item.count/2) - .5);
    
    if(current < 0) {
      current = count;
    }
    if(current > count) {
      current = 0;
    }
    
    //end block

    sync2
      .find(".owl-item")
      .removeClass("current")
      .eq(current)
      .addClass("current");
    var onscreen = sync2.find('.owl-item.active').length - 1;
    var start = sync2.find('.owl-item.active').first().index();
    var end = sync2.find('.owl-item.active').last().index();
    
    if (current > end) {
      sync2.data('owl.carousel').to(current, 100, true);
    }
    if (current < start) {
      sync2.data('owl.carousel').to(current - onscreen, 100, true);
    }
  }
  
  function syncPosition2(el) {
    if(syncedSecondary) {
      var number = el.item.index;
      sync1.data('owl.carousel').to(number, 100, true);
    }
  }
  
  sync2.on("click", ".owl-item", function(e){
    e.preventDefault();
    var number = $(this).index();
    sync1.data('owl.carousel').to(number, 300, true);
  });
});


// ------------pagination

// $('#sync1').on('changed.owl.carousel', function(e) {
//   if (!e.namespace || e.property.name != 'position') return
//   $('#info').text(e.item.index + '/' + e.item.count)
// })



























// -------------------------------------------



/* ---- Scrolling and tweening Script---- */
$(function() {
  
  var scrollMagicController = new ScrollMagic();
  
  var tween1 = TweenMax.to('#animation-1', 0.3, {
    backgroundColor: 'rgb(255, 39, 46)',
    scale: 10,
    rotation: 360
  });
  var scene1 = new ScrollScene({
    triggerElement: '#scene-1',
    offset: 50
  })
  .setClassToggle('body', 'scene-1-active')
  .setTween(tween1)
  .addTo(scrollMagicController);
  
    // Create Animation for 0.5s
  var tween2 = TweenMax.to('#animation-2', 0.3, {
    backgroundColor: 'rgb(0, 255, 187)',
    scale: 10,
    rotation: 360
  });
  
  var scene2 = new ScrollScene({
    triggerElement: '#scene-2',
		offset: 50
  })
  .setClassToggle('body', 'scene-2-active')
  .setTween(tween2)
  .addTo(scrollMagicController);
  
  
  
      // Create Animation for 0.5s
  var tween3 = TweenMax.to('#animation-3', 0.3, {
    backgroundColor: 'rgb(17, 0, 98)',
    scale: 10,
    rotation: 360
  });
  
  var scene3 = new ScrollScene({
    triggerElement: '#scene-3',
		offset: 50
  })
  .setClassToggle('body', 'scene-3-active')
  .setTween(tween3)
  .addTo(scrollMagicController);
  
  
  
  
  
  // Add debug indicators fixed on right side
   scene1.addIndicators();
     scene2.addIndicators();
  scene3.addIndicators();
  
});

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};

var tech = getUrlParameter('technology');
  alert("The text has been changed = "+tech);

$("#menu1").val(tech).trigger("change");

$("#menu1").change(function(){
  var get_menu_val = $(this).val();
  alert("The text has been changed = "+get_menu_val);
});

 $(function(){
      // bind change event to select
      $('#selectdropdown').bind('change', function () {
          var url = $(this).val(); // get selected value
          if (url) { // require a URL
              window.location = url; // redirect
          }
          return false;
      });
    });


//   $(document).getElementByClass('.al-dropdown').selectedIndex(function(){
//             if ($(this).value != 'None') {
//                   window.location.href = "https://clip-cart.myshopify.com/' + $(this).value;
//             };
//       });


$(function() {
      $('.al-dropdown').on('change',function() {
        
//             window.location.href = $(this).val();
        /*
         $('#selectdropdown').bind('change', function () {
          var url = $(this).val(); // get selected value
          if (url) { // require a URL
              window.location = url; // redirect
          }
          return false;
      });*/
      });
});


/* -------------------------------- */
              
        
// ===============================================
//         FOOTER 
// ===============================================
        
        
// ===============================================
//         CONTACT PAGE

// ===============================================
    
//---------------------------------------------------------------------
     // Add captcha in to form
    
//     var actCallback = function (response) {
//       $('#contactFormSubmit1').prop("disabled", false);//Take Captcha ID
//       $('#RecaptchaField1').remove();          //Take submit button ID
//     };
    
//     var expCallback = function () {
//       $('#contactFormSubmit1').prop("disabled", true);
//       alert("Apponitment is successfully aproved...!!");
//     };
    
//     var onloadCallback = function () {
//       var widget = grecaptcha.render(document.getElementById("RecaptchaField1"), {
//         'sitekey': "6LdS_bIUAAAAAPq9lvEHRv0Pl1-J2i5lQ2drJ6qs", // Sitekey, Retrieving from reCaptcha
//         'theme': "light",
//         'callback': actCallback,
//         'expired-callback': expCallback,
//       });
//     }
// ---------------------------------------------------------------------

// ---------------------------------------------------------------------
    // Add captcha in to form
    
//     var actCallback = function (response) {
//       $('#contactFormSubmit2').prop("disabled", false); //Take Captcha ID
//       $('#RecaptchaField2').remove();          //Take submit button ID
//     };
//     var expCallback = function () {
//       $('#contactFormSubmit2').prop("disabled", true);
//       alert("Apponitment is successfully aproved...!!");
//     };
    
//     var onloadCallback = function () {
//       var widget = grecaptcha.render(document.getElementById("RecaptchaField2"), {
//         'sitekey': "6LdS_bIUAAAAAPq9lvEHRv0Pl1-J2i5lQ2drJ6qs", // Sitekey, Retrieving from reCaptcha
//         'theme': "light",
//         'callback': actCallback,
//         'expired-callback': expCallback,
//       });
//     }
// ---------------------------------------------------------------------



// var urlmenu = document.getElementById( 'menu' );
// urlmenu.onchange = function() 
//  {
//    window.open( this.options[ this.selectedIndex ].value );
//  };


// if(Request.QueryString["menu"]!=null)
// {
// LoadData(Request.QueryString["menu"].tostring());
// }    

